import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useLegacyIframeResizeMessage from "../../hooks/useLegacyIframeResizeMessage";
import userValidationSchema from "../../validation/userValidation";
import CustomButton from "../../Components/Button/CustomButton";
import SmallFlexContainer from "../../Components/Container/smallFlexContainer";
import LoadingScreen from "../../Components/LoadingScreen/LoadingScreen";
import LargeContainer from "../../Components/Container/largeContainer";
import { maxBookingDate } from "../../utils/MaxBookingDate";
import { existingBookingSearch } from "../../bookingapi/booking.operations";
import Form from "../../Components/Forms/Form";
import PopUp from "../../Components/PopUp/PopUp";

const LandingPage = () => {
  useLegacyIframeResizeMessage();
  const navigate = useNavigate();

  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [formData, setFormData] = useState({
    customerFirstName: "",
    customerLastName: "",
    phoneNumber: "",
    customerId: "",
  });

  // prevent user from using browser back button
  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    const handlePopState = () => {
      window.history.pushState(null, "", window.location.href);
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  function handleFormChange(event) {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  }

  const onContinuePress = async () => {
    setLoader(true);
    userValidationSchema
      .validate(formData, { abortEarly: false })
      .then(async () => {
        setErrors({});
        try {
          const existingBooking = await existingBookingSearch(
            formData.customerId,
            formData.phoneNumber
          );
          const maxDate = await maxBookingDate(formData.customerId);

          const timestamp = existingBooking?.[0]?.dayId?.date;
          const bookingDate = new Date(timestamp);
          const currentDate = new Date();
          const bookingId = existingBooking?.[0]?.bookingId;
          const existingBookingToken = existingBooking?.[0]?.token;

          if (bookingDate < currentDate) {
            navigate("/add-booking", {
              state: {
                ...formData,
                maxDate,
                overwriteExistingBooking: true,
                bookingId,
                existingBookingToken,
              },
            });
          } else if (existingBooking && existingBooking.length > 0) {
            navigate("/update-booking", {
              state: {
                ...formData,
                maxDate,
              },
            });
          } else {
            navigate("/add-booking", {
              state: {
                ...formData,
                maxDate,
              },
            });
          }
        } catch (error) {
          setLoader(false);
          setIsPopUpOpen(true);
        }
      })
      .catch((validationError) => {
        const errors = validationError.inner.reduce(
          (acc, curr) => ({
            ...acc,
            [curr.path]: curr.message,
          }),
          {}
        );
        setLoader(false);
        setErrors(errors);
      });
  };

  return (
    <LargeContainer minH={"100vh"}>
      <SmallFlexContainer px={{ base: "5%", md: "20%" }} alignItems={"center"}>
        <SmallFlexContainer width="55%" alignItems={"center"}>
          {isPopUpOpen && (
            <PopUp
              popUpHeading={"There's been an issue"}
              popUpMessage={
                "Please review your details, if you have already registered, please check your details match your original booking to retrieve it."
              }
              isOpen={isPopUpOpen}
              onClose={() => setIsPopUpOpen(false)}
            />
          )}
          {loader ? (
            <LoadingScreen
              loadingText={"Hold tight"}
              loadingSubText={"It will just take a few moments"}
            ></LoadingScreen>
          ) : (
            <SmallFlexContainer
              backgroundColor={"#FFFFFF"}
              alignItems={"center"}
            >
              <Form
                formData={formData}
                handleFormChange={handleFormChange}
                errors={errors}
              ></Form>
              <CustomButton
                marginTop={"32px"}
                marginBottom={"32px"}
                onClick={onContinuePress}
                buttonLabel={"Continue"}
              ></CustomButton>
            </SmallFlexContainer>
          )}
        </SmallFlexContainer>
      </SmallFlexContainer>
    </LargeContainer>
  );
};

export default LandingPage;
